export default "__VITE_ASSET__26175c2b__"